import { Drawer, type DrawerProps } from 'antd';
import s from './OrgStructureSelectDrawer.module.scss';

export const ORG_STRUCTURE_SELECT_DRAWER_TITLE = 'Выбор подразделения';

export type OrgStructureSelectDrawerProps = Omit<DrawerProps, 'placement'>;

export function OrgStructureSelectDrawer({
  className,
  children,
  title = ORG_STRUCTURE_SELECT_DRAWER_TITLE,
  ...rest
}: OrgStructureSelectDrawerProps) {
  return (
    <Drawer placement="right" title={title} className={[s.root, className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </Drawer>
  );
}
